import {
    TableActionIdentifiers,
    TableFetchFailedActionType,
    TableFetchStartedActionType,
    TableFetchSucceededActionType,
} from "#store/tables/tableTypes";
import { MetadataTable } from "#services/pilotService/types";
import { action as createAction } from "@iva/store-utils";
import { IQueryTableResult } from "#services/pilotService/responses/types";
import { AppDispatch, ErrorPayload, GetState, ThunkResult } from "#store/types";
import { Dispatch } from "redux";

import { pilotService } from "#/services";
import { isTable } from "#/util/typeUtils";
import { shouldRefetch } from "#/util/shouldRefetch";
import { ThunkAction } from "redux-thunk/src/types";

/*******************************************************************************
 * Actions
 ******************************************************************************/

/**
 * @deprecated This method is dangerous because the reducer item does not
 * contain a interpretationId in all cases.
 *
 * TODO
 *
 * @param tableId
 */
export function fetchTableFromServer(tableId: number): ThunkResult {
    return (dispatch, getState) => {
        if (shouldRefetch(getState().tables.tableResults[tableId])) {
            dispatch(tableFetchStarted(tableId));
            pilotService
                .tableService(
                    getState().environment.SERVICE_URL,
                    getState().uiState.rid
                )
                .getTableData(tableId)
                .then((table: any) => {
                    if (isTable(table)) {
                        const t = new IQueryTableResult(table, tableId);
                        dispatch(tableFetchSuccess(t));
                    } else {
                        console.warn("data received is not a table");
                    }
                })
                .catch(error => {
                    dispatch(
                        tableFetchFailed({
                            id: tableId,
                            error: error,
                            message: `failed to receive table for id ${tableId}`,
                        })
                    );
                });
        }
    };
}

export function tableFetchStarted(id: number): TableFetchStartedActionType {
    return createAction(TableActionIdentifiers.FETCH_TABLE_STARTED, id);
}

export function tableFetchSuccess(
    table: IQueryTableResult
): TableFetchSucceededActionType {
    return createAction(TableActionIdentifiers.FETCH_TABLE_SUCCEEDED, table);
}

export function tableFetchFailed(
    error: ErrorPayload
): TableFetchFailedActionType {
    return createAction(TableActionIdentifiers.FETCH_TABLE_FAILED, error);
}
